<template>
  <div class="circledetails">
    <div class="body">
      <div class="body_nav">
        <div>
          <img :src="liaotjl.avatar" alt="" />
        </div>
        <div>
          <h1>{{ liaotjl.name }}</h1>
        </div>
      </div>
      <div class="content">
        <span>{{ liaotjl.content }}</span>
      </div>
      <div class="imgs" v-if="liaotjl.if_image == 1">
        <img
          :src="item"
          alt=""
          v-for="(item, index) in liaotjl.url"
          :key="index"
          @click="onpreview(index)"
        />
      </div>
      <div class="imgs" v-if="liaotjl.if_image == 2">
        <video width="10rem" height="auto" controls>
          <source :src="liaotjl.url" type="video/mp4" />
        </video>
      </div>
      <div class="list">
        <div>
          <span>{{ liaotjl.show_day }}</span>
          <span
            @touchstart="clicka"
            @touchend="jj"
            @click="delet"
            :style="aa"
            v-if="datalist.userid == datalist.userid_obse"
            >删除</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { Area } from "vant";
import Comments from "@/components/comment.vue";
import { ImagePreview } from "vant";
export default {
  name: "mine",
  data() {
    return {
      list: "hallo word",
      aa: "",
      datalist: {},
      liaotjl: {},
      imgs: [],
      zhuangt: "",
      plzt: "",
      comment: {},
      value: "",
      name: {},
    };
  },
  components: {
    Comments,
  },
  mounted() {
    this.datalist = this.$route.query;
    this.aaa();
    this.pinlun();
  },

  methods: {
    onpreview(index) {
      ImagePreview({
        images: this.liaotjl.url,
        startPosition: index,
      });
    },
    reception(name) {
      this.name = name;
      this.$refs.input.focus();
    },
    fire() {
      this.axios
        .post(
          "/crm/CircleFriends/circleComment",
          qs.stringify({
            userid: this.datalist.userid,
            account_id: this.datalist.account_id,
            friends_id: this.datalist.item.id,
            content: this.value,
            to_user: this.name.userid,
            parent_id: this.name.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.value = "";
            Toast(res.data.msg);
            this.pinlun();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    pinlun() {
      this.axios
        .post(
          "/crm/CircleFriends/getCommentList",
          qs.stringify({
            userid: this.datalist.userid,
            account_id: this.datalist.account_id,
            friends_id: this.datalist.item.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.comment = res.data.data;
          this.plzt = res.data.code;
        })
        .catch(function (err) {});
    },
    dianzan() {
      this.axios
        .post(
          "/crm/CircleFriends/likeList",
          qs.stringify({
            userid: this.datalist.userid,
            account_id: this.datalist.account_id,
            id: this.datalist.item.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.imgs = res.data.data;
          this.zhuangt = res.data.code;
        })
        .catch(function (err) {});
    },
    zhang() {
      if (this.liaotjl.if_like == 1) {
        this.axios
          .post(
            "/crm/CircleFriends/circleLike",
            qs.stringify({
              userid: this.datalist.userid,
              friends_id: this.datalist.item.id,
              cancel: 2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            Toast(res.data.msg);
            this.dianzan();
            this.aaa();
          })
          .catch(function (err) {});
      } else {
        this.axios
          .post(
            "/crm/CircleFriends/circleLike",
            qs.stringify({
              userid: this.datalist.userid,
              friends_id: this.datalist.item.id,
              cancel: 1,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            this.dianzan();
            this.aaa();
            Toast(res.data.msg);
          })
          .catch(function (err) {});
      }
    },
    delet() {
      this.axios
        .post(
          "/crm/CircleFriends/delCircleFriends",
          qs.stringify({
            userid: this.datalist.userid,
            ids: this.datalist.item.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if ((res.data.code = 1)) {
            Toast(res.data.msg);
            this.$router.replace("/circle");
          }
        })
        .catch(function (err) {});
    },
    aaa() {
      this.axios
        .post(
          "/crm/CircleFriends/CircleFriendsOne",
          qs.stringify({
            userid: this.datalist.userid,
            account_id: this.datalist.account_id,
            id: this.datalist.item.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.liaotjl = res.data.data;
        })
        .catch(function (err) {});
    },
    clicka() {
      this.aa = "background-color: rgb(229,229,229);";
    },
    jj() {
      this.aa = "";
    },
    aac() {
      this.$router.replace("circle");
    },
  },
};
</script>
<style scoped>
.nav {
  width: 100%;
  height: 5rem;
  position: fixed;
  background-color: rgba(237, 237, 237);
  line-height: 5rem;
  top: 0;
  z-index: 1000;
}
.nav > div {
  width: 10rem;
  height: 100%;
}
.nav > div > span {
  margin-left: 1rem;
}
.body {
  width: 100%;
}
.body_nav {
  width: 95%;
  margin: 0 auto;
  padding: 1rem .5rem;
  display: flex;
  align-items: flex-start;
}
.body_nav > div:nth-child(1) {
  display: inline-block;
  width: 20%;
  height: 5rem;
}
.body_nav > div:nth-child(1) > img {
  width: 5rem;
  height: 5rem;
}
.body_nav > div:nth-child(2) {
  width: 80%;
  height: 5rem;
  min-width: 5rem;
  display: inline-block;
}
.body_nav > div:nth-child(2) > h1 {
  /* margin-left: 1rem; */
  font-size: 1.7rem;
  color: rgb(79, 92, 127);
}
.body_nav > div:nth-child(2) > span {
  width: 100%;
  display: -webkit-box;
}
.content {
  margin-left: 23%;
  width: 70%;
  position: relative;
  bottom: 3rem;
}
.content > span {
  font-size: 1.6rem;
  color: rgb(71, 71, 71);
  font-weight: 400;
}
.imgs {
  margin-left: 23%;
  width: 70%;
  position: relative;
  bottom: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.imgs > img {
  width: 33%;
  height: 9rem;
  margin: .1rem 0;
}
.list {
  margin-left: 23%;
  width: 70%;
  position: relative;
  bottom: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.list > div:nth-child(1) {
  font-size: 1.5rem;
  color: rgb(146, 158, 146);
}
.list > div:nth-child(1) > span:nth-child(1) {
  margin-right: 1rem;
}
.list > div:nth-child(1) > span:nth-child(2) {
  color: rgb(79, 92, 127);
}
.yejiao {
  position: relative;
  top: .5rem;
}
.yejiao > span {
  padding: .4rem 1rem;
  background-color: rgb(187, 187, 187);
  margin-left: 1rem;
  color: #fff;
  line-height: 2.5rem;
}

.pinglun {
  width: 90%;
  margin: 0 auto;
  background-color: rgb(247, 247, 247);
  border-radius: .5rem;
  padding: .5rem 1rem;
}
.imgsxin {
  padding: .5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.imgsxin > div {
  width: 90%;
  display: inline-block;
}
.imgsxin > div > img {
  width: 2.5rem;
  height: auto;
  margin-left: 1rem;
}
.pingun > div {
  height: 3rem;
}
.pingun > div > img {
  width: 2.5rem;
  height: auto;
  margin-left: 1rem;
}
.pinguns > div {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.pinguns > div > img {
  width: 2.5rem;
  height: auto;
}
.zitui {
  display: inline-block;
  /* position: relative; */
  width: 80%;
  margin-left: 1rem;

  /* height: 3rem; */
}
.zitui > p {
  color: rgb(79, 92, 127);
  display: inline-block;
  width: 10rem;
  overflow: hidden;
}
.zitui > span:nth-child(2) {
  float: right;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  /* height: 5rem; */
  /* background-color: red; */
}
.van-cell {
  margin-top: 0;
}
</style>
